/* import __COLOCATED_TEMPLATE__ from './plc.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();